var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPermissions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16158_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4003 16.6641L21.0225 18.9307C20.5781 19.6863 19.6003 19.9085 18.8892 19.4641L17.2003 18.4418C16.4892 19.0196 15.7336 19.4641 14.8892 19.7752V21.7752C14.8892 22.6196 14.1781 23.3307 13.3336 23.3307H10.667C9.82252 23.3307 9.11141 22.6196 9.11141 21.7752V19.8196C8.17807 19.4641 7.33363 18.9752 6.62252 18.3529L4.88918 19.2863C4.13363 19.7307 3.20029 19.4196 2.75585 18.7085L1.46696 16.3974C1.02252 15.6418 1.33363 14.7085 2.04474 14.2641L3.77807 13.3307C3.68918 12.8863 3.68918 12.4418 3.68918 11.9974C3.68918 11.4641 3.73363 10.9307 3.82252 10.4418L2.13363 9.41962C1.37807 8.97517 1.15585 7.9974 1.60029 7.28628L2.97807 5.01962C3.42252 4.26406 4.4003 4.04184 5.11141 4.48628L6.8003 5.50851C7.51141 4.93073 8.26696 4.48628 9.11141 4.17517V2.21962C9.11141 1.37517 9.82252 0.664062 10.667 0.664062H13.3336C14.1781 0.664062 14.8892 1.37517 14.8892 2.21962V4.17517C15.8225 4.53073 16.667 5.01962 17.3781 5.64184L19.067 4.66406C19.8225 4.21962 20.7559 4.48628 21.2003 5.24184L22.4892 7.55295C22.9336 8.30851 22.6225 9.24184 21.9114 9.68628L20.2225 10.6641C20.3114 11.1085 20.3114 11.553 20.3114 11.9974C20.3114 12.5307 20.267 13.0196 20.1781 13.553L21.867 14.5752C22.6225 14.9752 22.8447 15.953 22.4003 16.6641Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 15.3307C10.1781 15.3307 8.66699 13.8196 8.66699 11.9974C8.66699 10.1752 10.1781 8.66406 12.0003 8.66406C13.8225 8.66406 15.3337 10.1752 15.3337 11.9974C15.3337 13.8196 13.8225 15.3307 12.0003 15.3307Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16158_1666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissions);
export default __webpack_public_path__ + "static/media/permissions.d52599af0a428f1ebbe1c8a916fbbbdc.svg";
export { ForwardRef as ReactComponent };